import {Component, createRef} from 'react';

import ButtonNext from '../buttons-navigation/button-next';
import ButtonPrevious from '../buttons-navigation/button-previous';
import ButtonCancel from '../buttons-navigation/button-cancel';

import AccessCompany from './access-company';
import Page from './page/page';
import PageHeader from './page/page-header';

import AccessPage from './access-page';

import ApplicationHeader from '../../views/grants-application/grants-application-header';

import ApplicationApi from '../../lib/applications/application-api';
import alertManager from '../../managers/alert/alert-manager';

import MediaQuery from 'react-responsive';

export default class StateManagedPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
            checkboxes: [],
            pages: this.props.pages || [],
            errors: false,
            nextText : 'next'
        }

        this.ref = createRef();

        this.layout = document.querySelector('.layout__main-container');

        this.onProceed = null;
    }

    componentDidMount() {
        this.layout = document.querySelector('.layout__main-container');

        this.state.pages.forEach(({data, title}) => {
            let checkboxList = []

            data.forEach(({title, items}) => {
                const checkboxes = items.filter(i => i.type == 'checkbox').map(d => ({
                    ...d,
                    questionTitle: title,
                }));

                if (checkboxes.length > 0) checkboxList = [...checkboxes, ...checkboxList]
            });

            if (checkboxList.length > 0) {
                this.addCheckboxes(title, checkboxList);
            }
        })
    }

    setErrors(bool) {
        this.setState({ errors: bool })
    }

    addCheckboxes(title, items) {
        let checkboxes = [...items];

        checkboxes = checkboxes.map(checkbox => ({
            belongsTo: title,
            label: checkbox.label || '',
            value: checkbox.value,
            required: checkbox.required,
            questionTitle: checkbox.questionTitle,
            checked: false,
            error: null,
        }))

        this.setState({ checkboxes })
    }

    doesCheckboxExist(item) {
        return this.getCheckbox(item) !== undefined;
    }

    getCheckbox(item) {
        return this.state.checkboxes.find(i => item.questionTitle == i.questionTitle && item.value == i.value);
    }

    getCheckboxByLabel(label) {
        return this.state.checkboxes.find(i => label == i.label);
    }

    isCheckboxToggled(item) {
        return this.doesCheckboxExist(item) ? this.getCheckbox(item).checked : false;
    }

    onCheckboxClicked(item, {value}) {
        const checkboxes = [...this.state.checkboxes];

        const checkbox = this.getCheckbox(item);

        checkbox.checked = value;

        if (checkbox.error && value) {
            this.setCheckboxError(checkbox, '');
        }

        this.setState({checkboxes});
    }

    setCheckboxError(item, error) {
        const checkboxes = [...this.state.checkboxes];

        const checkbox = this.getCheckbox(item);

        checkbox.error = error;

        this.setState({checkboxes});
    }

    startApplication() {

        const notCheckedCount = this.state.checkboxes.filter(box => {
            if (box.required) this.setCheckboxError(box, !box.checked ? 'You need to accept' : '');

            return !box.checked && box.required;
        })

        if (notCheckedCount.length > 0) return;

        const api = new ApplicationApi();

        const eligibilityPage = this.state.pages[this.state.pages.length - 1];

        const data = eligibilityPage.data.filter(e => {
            return e.include_eligibility === true

        }).map(d => ({
            title: d.title,
            description: d.description,
            responses: this.state.checkboxes.filter(c => c.questionTitle == d.title && c.checked).map(c => c.label)
        }));

        api.create(this.props.grantId, data).then(data => {
            window.location.href = '/myeb/grants/applications/' + data.id;
        });
    }

    nextPageClick() {
        if (this.state.currentPage == this.state.pages.length) return;

        if(this.onProceed !== null ) {
            this.onProceed().then(() => {
                this.setState(state => ({currentPage: state.currentPage + 1}));
            });

        }else {
            this.setState(state => ({currentPage: state.currentPage + 1}));

        }

        if (this.layout !== null) this.layout.scrollIntoView();

    }

    backPageClick() {
        if (this.state.currentPage < 1) return;

        this.onProceed = () => {};

        this.setState(state => ({ errors: false, currentPage: state.currentPage - 1}));

        if (this.layout !== null) this.layout.scrollIntoView();
    }

    render() {
        const { title, grant, subtitle, data, Component } = this.state.pages[this.state.currentPage - 1];

        const canStartApplication = this.state.checkboxes.filter(box => !box.checked && box.required).length == 0;

        const top = (
            <>
                <div className="utils__row">
                    Section: <div className="utils__row pagination__circles">
                    {new Array(this.state.pages.length).fill(1).map((_, index) => <div
                        className="pagination-circle">{index + 1}</div>)}
                </div>
                </div>
                <div className="state-pages-header__row">
                    <ButtonCancel onClick={() => window.location.href = '/myeb/grants'}>Cancel</ButtonCancel>
                </div>
            </>
        );

        const nextText = this.state.nextText;

        const header = <ApplicationHeader navigation={
            <>
                <div className="state-pages-header__end">
                    <ButtonCancel onClick={() => window.location.href = '/myeb/grants'}>Cancel</ButtonCancel>
                </div>
            </>}
            title={<>
            <div className="state-pages-header__row">
                <h2 className="state-pages-header__title">{ title }</h2>
            </div>
            <div className="state-pages-header__row">
                <MediaQuery maxWidth={568}>
                    { this.props.customPagination == null &&
                        <div className="utils__row utils__gap--20">
                            { this.state.currentPage - 1 > 0 && <ButtonPrevious onClick={this.backPageClick.bind(this)}>Back</ButtonPrevious> }
                            {this.state.currentPage == this.state.pages.length && <ButtonNext background={true} disabled={!canStartApplication} onClick={this.startApplication.bind(this)}>Start Application</ButtonNext>}
                            { this.state.currentPage !== this.state.pages.length && <ButtonNext disabled={this.state.errors} onClick={this.nextPageClick.bind(this)}>{nextText}</ButtonNext> }
                        </div>
                    }
                </MediaQuery>

                <MediaQuery minWidth={568}>
                    { this.props.customPagination == null &&
                        <div className="utils__row utils__gap--20">
                            { this.state.currentPage - 1 > 0 && <ButtonPrevious onClick={this.backPageClick.bind(this)}>Back</ButtonPrevious> }
                            {this.state.currentPage == this.state.pages.length && <ButtonNext background={true} disabled={!canStartApplication} onClick={this.startApplication.bind(this)}>Start Application</ButtonNext>}
                            { this.state.currentPage !== this.state.pages.length && <ButtonNext disabled={this.state.errors} onClick={this.nextPageClick.bind(this)}>{nextText}</ButtonNext> }
                        </div>
                    }
                </MediaQuery>
            </div>
        </>} subtitle={<>
            <div className="state-pages-header__row">
                <h2 className="state-pages-header__subtitle">{ subtitle }</h2>
            </div>
            <div className="state-pages-header__row">
                <h2 className="state-pages-header__pages">{this.state.currentPage} of {this.state.pages.length}</h2>
            </div>
        </>}/>

        const content = (
            <Component data={data}
                       grant={grant}
                       ref={this.ref}
                       setOnProceed={callback => this.onProceed = callback}
                       setErrors={this.setErrors.bind(this)}
                       setNextText={text => this.setState({nextText : text})}
                       onCheckboxClicked={this.onCheckboxClicked.bind(this)}
                       doesCheckboxExist={this.doesCheckboxExist.bind(this)}
                       isCheckboxToggled={this.isCheckboxToggled.bind(this)}
                       checkboxes={this.state.checkboxes.filter(e => e.belongsTo == title)}/>
        )

        return (
            <Page header={header} content={content}/>
        )
    }
}
